(function($, exports) {


	exports.init = function() {
		var $menuButton = $('.menu-button');
		var $body = $('body');

		$menuButton.on('click', function() {
			$body.toggleClass('is-open-mobile');
		});

		$('html').on('click', function(e) {

			if(!$(e.target).closest('.l-header').length) {  
				$body.removeClass('is-open-mobile');
			} 
			
		});
	};
	
})(jQuery, this.NAV = {});